import {
  Box,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import clsx from "clsx";
import { ButtonCust } from "../../../widgets";
import { calculateCost, calculateUnlimitedCost, PlanProps } from "./PlanCard";
import styles from "./S13_PlanCard.module.scss";
import Config from "../../../../config/env.config.json";
import { GetCurrencyFixedToTwo } from "../../../../utils/commonFunctions/GetCurrencyFixedToTwo";

const T13_PlanCard = (props: PlanProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    plandata,
    planContent,
    tagLabel,
    tagBgColor,
    tagTxtColor,
    selectedLine,
    planSelectionHandler,
  } = props;

  let details: any = localStorage.getItem("customerDetail");
  details = JSON.parse(details);
  const {
    cards_div,
    plans_div,
    plan_page_plan_card,
    current_plan,
    fade_out,
    home_page_plan_card,
    tag,
    wrapper_div,
  } = styles;
  const {
    per_month_text,
    mbl_img,
    video_img,
    tax_text,
    btn_txt,
    data,
    hd_vid,
    sd_vid,
  } = planContent || {};

  return (
    <Stack className={wrapper_div}>
      <Grid container className={clsx(cards_div, plans_div)}>
        {plandata.length > 0 &&
          plandata.map((el: any, index: number) => {
            const { planCost, planPerLinesCost } = el?.unlimited
              ? calculateUnlimitedCost(el, selectedLine)
              : calculateCost(el, selectedLine);
            const isCurrentPlan =
              details?.reachPlanDisplayName === el?.displayName;
            return (
              <Card
                id={`home${index}`}
                key={index}
                className={clsx(
                  home_page_plan_card,
                  plan_page_plan_card,
                  isCurrentPlan ? current_plan : ""
                )}
                raised
                elevation={isMobile ? 0 : 8}
              >
                {isCurrentPlan && (
                  <>
                    {!tagLabel && (
                      <Box
                        className={tag}
                        sx={{
                          backgroundColor: tagBgColor
                            ? tagBgColor
                            : "var(--primary_background)",
                          color: tagTxtColor ? tagTxtColor : "var(--white)",
                        }}
                      >
                        {planContent?.current_plan}
                      </Box>
                    )}
                  </>
                )}
                <Typography
                  component={"h5"}
                  sx={{
                    fontFamily: "var(--font_family_Semibold)",
                    fontSize: { xs: "20px", md: "20px" },
                    color: "var(--text_color_12)",
                    fontWeight: "600",
                    my: "6px",
                    textAlign: "center",
                  }}
                >
                  {el.displayName}
                </Typography>
                <Typography
                  component={"div"}
                  sx={{
                    fontFamily: "var(--font_family_Semibold)",
                    fontSize: { xs: "20px", md: "20px" },
                    color: "var(--text_color_12)",
                    fontWeight: "600",
                    my: "6px",
                    textAlign: "center",
                  }}
                >
                  {el.planData + el.dataUnit}
                </Typography>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    component={"span"}
                    sx={{
                      fontSize: "32px",
                      fontFamily: "var(--font_family_Bold)",
                      color: "var(--primary_color)",
                    }}
                  >
                    <Typography
                      component={"span"}
                      sx={{
                        fontSize: "28px",
                        fontFamily: "var(--font_family_Semibold)",
                        color: "inherit",
                      }}
                    >
                      $
                      {GetCurrencyFixedToTwo(
                        planCost ? planCost : 0,
                        el.currency ? el.currency : "usd",
                        true
                      )}
                    </Typography>
                    <Typography
                      component={"span"}
                      sx={{
                        fontFamily: "var(--font_family_Semibold)",
                        fontSize: "10px",
                        color: "var(--text_color_12)",
                      }}
                    >
                      {per_month_text}
                    </Typography>
                    <Typography
                      component={"div"}
                      sx={{
                        fontFamily: "var(--font_family_Regular)",
                        fontSize: "12px",
                        color: "var(--black)",
                        my: "10px",
                      }}
                    >
                      {tax_text}
                    </Typography>
                  </Typography>
                </Box>
                <Box
                  className={el.maxLines >= selectedLine ? " " : fade_out}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    my: "15px",
                  }}
                >
                  <ButtonCust
                    variantType={Config.PRIMARY_BUTTON_TYPE}
                    className={el.maxLines >= selectedLine ? " " : fade_out}
                    onClick={(e: any) => {
                      el.maxLines >= selectedLine
                        ? planSelectionHandler(el, btn_txt)
                        : "";
                    }}
                  >
                    {btn_txt}
                  </ButtonCust>
                </Box>
              </Card>
            );
          })}
        {isMobile && (
          <Typography
            component={"div"}
            style={{
              opacity: 0,
            }}
          >
            div
          </Typography>
        )}
      </Grid>
    </Stack>
  );
};

export default T13_PlanCard;
